export default __webpack_public_path__ + "static/media/TabbyDIY.6cd09d24.png";